import GET_LINK_BLOCK from '../plugins/get-link-block'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const init = () => {

  if( w.load['loadHtml'] ){
    w.load['loadHtml'].then( () => {
      // ナビゲーションカレント
      $('.nav-salon[data-plugin="currentMenu"]').currentMenu({mode:0})
    })
  }

  // リンクブロック 呼び出し
  $.when( w.load['salon-01'] ).then( () => {
    GET_LINK_BLOCK()
  })
  $.when( w.load['salon-02'] ).then( () => {
    GET_LINK_BLOCK()
  })
}

export default function SALON() {
  $( init )
}